export const getSortedItems = (data, tab) => {
    const blockSorter = (a, b) => {
      let a_top = data[tab][a].top;

      // case of a list of checkboxes
      if (data[tab][a].items && data[tab][a].items.length > 0) {
        a_top = data[tab][a].items[0].top;
      }
      // case of matrix
      if (data[tab][a].matrixTop) {
        a_top = data[tab][a].matrixTop;
      }

      let b_top = data[tab][b].top;
      // case of a list of checkboxes
      if (data[tab][b].items && data[tab][b].items.length > 0) {
        b_top = data[tab][b].items[0].top;
      }

       // case of matrix
       if (data[tab][b].matrixTop) {
        b_top = data[tab][b].matrixTop;
      }

      if (Number(a_top) < Number(b_top)) return -1;
      if (Number(a_top) > Number(b_top)) return 1;
      return 0;
    };

    if (!data || !data[tab]) {
      return [];
    }

    let _items = Object.keys(data[tab]).reduce((arr, itemKey) => {
      arr.push(itemKey);
      return arr;
    }, []);

    _items = _items.sort(blockSorter);

    const _sortedItems = _items.reduce((dataObj, itemKey) => {
      dataObj[itemKey] = data[tab][itemKey];
      return dataObj;
    }, {});

    return _items;
  };
